/**
 * Created by Ondra on 20.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import DateTime from '../components/numbers/DateTime';
import {FormattedNumber} from 'react-intl';
import {
    countDiscountPrice,
    countDiscountPriceWithoutRound,
    betterRound,
    isNeedArrayPrint,
    countTotalItemsPrice
} from '../../common/lib/util';
import Percent from "../components/numbers/Percent";

class Print extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        bar: React.PropTypes.object,
        branch: React.PropTypes.object,
        organization: React.PropTypes.object,
        orderToPrint: React.PropTypes.object,
        tableToPrint: React.PropTypes.object,
        logo: React.PropTypes.string,
        printType: React.PropTypes.string,
        cashboxes: React.PropTypes.object,
        dailySum: React.PropTypes.object,
        printDailySum: React.PropTypes.bool,
        deviceId: React.PropTypes.number,
        className: React.PropTypes.string
    };

    render() {
        const {
            bar, organization, orderToPrint, branch, cashboxes, tableToPrint, printDailySum, dailySum,
            deviceId, logo, className, printType, msg
        } = this.props;

        if (!!isNeedArrayPrint(printType)) {
            return null;
        }

        if (!organization || !bar) {
            return null;
        }

        let toPrint = orderToPrint;
        if (!!printDailySum) {
            toPrint = dailySum;
        } else if (!!tableToPrint) {
            toPrint = tableToPrint;
        }

        if (toPrint === null || !toPrint || typeof toPrint === 'undefined') {
            return null;
        }

        let fiscalize = false;
        if (organization.get('fiscalize')) {
            fiscalize = !!cashboxes && cashboxes.getIn([toPrint.get('cashbox'), 'fiscalize']);
        }

        const itemsToPrint = !!toPrint.get('items') ? toPrint.get('items') : toPrint.get('selectedProducts');
        const discount = !!toPrint.get('discount') ? toPrint.get('discount') : 0;
        const totalPricePreRound = !!toPrint.get('totalPriceVat')
            ? toPrint.get('totalPriceVat')
            : !!itemsToPrint
                ? countTotalItemsPrice(itemsToPrint)
                : 0;
        const totalPriceRound = Math.round(totalPricePreRound);
        const discountPrice = countDiscountPrice(totalPriceRound, discount);
        const totalPrices = toPrint.get('totalPrices');

        return (
            <div id="print-receipt" className={`${!!className ? className : ''}`}>
                {!!logo &&
                <div>
                    <img className="logo-print" src={logo}/>
                </div>
                }
                <h1>
                    <span className="menu-hide">
                        {branch.get('name')}
                    </span>
                    {!!toPrint.get('storno') &&
                    <span><br/>{msg.print.storno}</span>
                    }
                    {!!toPrint.get('note') &&
                    <span>
                        <br/>
                        {msg.print.bill}: {toPrint.get('note')}
                    </span>
                    }
                    {!!toPrint.get('title') &&
                    <span>
                        <br/>
                        {msg.print}: {toPrint.get('title')}
                    </span>
                    }
                    {!!tableToPrint &&
                    <span>
                        <br/>
                        {msg.print.bill}: {tableToPrint.get('name')}
                    </span>
                    }
                    {!!printDailySum &&
                    <span>
                        <br/>
                        <DateTime showSec value={Date.now()}/>
                    </span>
                    }
                </h1>

                {!!!toPrint.get('isInformative') &&
                    <center className="menu-hide">
                        <small>
                            {organization.get('name')}, {bar.get('name')}, {!!cashboxes && cashboxes.getIn([toPrint.get('cashbox'), 'name'])}<br/>
                            {msg.print.idNumber} {organization.get('regnr')}, {msg.print.vatId} {organization.get('vatId')}<br/>
                            {organization.getIn(['address', 'name'])}
                        </small>
                    </center>
                }

                {!!toPrint.get('kitchenNumber') &&
                    <center className="menu-hide">
                        <br/>
                        <h1>
                            {msg.print.orderNum}: {toPrint.get('kitchenNumber') }
                        </h1>
                        <br/>
                    </center>
                }

                <hr className="menu-hide"/>
                {!!toPrint.get('isInformative') &&
                    <center>
                        <span className="no-receipt-warning">{msg.print.notReceipt}</span>
                    </center>
                }
                <table className="percent100">
                    <tbody>
                    {!!itemsToPrint && itemsToPrint.size === 0 && !!printDailySum &&
                    <tr>
                        <td>{msg.print.reportNotOpen}</td>
                    </tr>
                    }

                    {!!itemsToPrint && itemsToPrint.map((item, i) =>
                        <tr key={`print-item-${i}`}>
                            <td width="10%" className="right">{item.get('pcs')}x</td>
                            <td width="70%">{item.get('name')}
                                &nbsp;
                                (<FormattedNumber style="decimal"
                                                  maximumFractionDigits={2}
                                                  minimumFractionDigits={2}
                                                  value={(item.get('price')).toFixed(2)}/>)
                                &nbsp;
                                {!!item.get('discount') && `-${betterRound(item.get('discount'), 0)}%`}
                            </td>
                            <td width="20%" className="right">
                                {typeof item.get('pcs') !== 'undefined' &&
                                <FormattedNumber
                                    style="decimal"
                                    maximumFractionDigits={2}
                                    minimumFractionDigits={2}
                                    value={countDiscountPriceWithoutRound((item.get('price') * item.get('pcs')), item.get('discount')).toFixed(2)}/>
                                }
                            </td>
                        </tr>
                    )}

                    </tbody>
                </table>
                <hr/>

                {typeof totalPricePreRound !== 'undefined' && totalPricePreRound !== null &&
                <div className="right">
                    {discount > 0 &&
                    <div>
                        {msg.print.discount} <Percent value={discount}/> CZK <FormattedNumber
                        style="decimal"
                        maximumFractionDigits={2}
                        minimumFractionDigits={2}
                        value={Math.round(totalPriceRound - discountPrice)}/>
                    </div>
                    }
                    <span id="total">
                        CZK <FormattedNumber
                        style="decimal"
                        maximumFractionDigits={2}
                        minimumFractionDigits={2}
                        value={Math.round(discountPrice)}/>
                    </span>
                </div>
                }

                {!!organization.get('vatPayer') && !!totalPrices && totalPrices.filter(vat => vat.get('sum') > 0).map((vat, i) => {
                    return (
                        <div className="right" key={`vat-${i}`}>
                            <small>
                                {`${msg.print.vat} ${vat.get('vat')}% CZK `}
                                <FormattedNumber
                                    style="decimal"
                                    maximumFractionDigits={2}
                                    minimumFractionDigits={2}
                                    value={(vat.get('sum') - (vat.get('sum') / (1 + vat.get('vat') / 100.0))).toFixed(2)}/>
                            </small>
                        </div>
                    );
                })}
                {!organization.get('vatPayer') &&
                <div className="right">
                    <small>
                        {msg.print.noVat}
                    </small>
                </div>
                }

                {!!printDailySum &&
                  <br/>
                }

                {!!printDailySum &&
                <table style={{width: '100%'}}>
                    <br/>
                    <tbody>
                    {!!toPrint.get('cashboxesSums') && toPrint.get('cashboxesSums').map(cashbox =>
                        <tr key={`cashboxesSums-${cashbox.get(0)}`}>
                            <td>{cashbox.get(0)}:</td>
                            <td className="right">
                                <FormattedNumber style="decimal"
                                                 maximumFractionDigits={2}
                                                 minimumFractionDigits={2}
                                                 value={cashbox.get(1).toFixed(2)}/> CZK
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td colSpan={2}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>{msg.print.sale}:</td>
                        <td className="right">
                            <FormattedNumber
                                style="decimal"
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                                value={(toPrint.getIn(['report', 'salePriceMagic', 'CZK'])).toFixed(2)}/> CZK
                        </td>
                    </tr>
                    <tr>
                        <td>{msg.print.turnover}:</td>
                        <td className="right">
                            <FormattedNumber
                                style="decimal"
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                                value={(-1 * toPrint.getIn(['report', 'cashboxesPriceMagic', 'CZK'])).toFixed(2)}/> CZK
                        </td>
                    </tr>
                    <tr>
                        <td>{msg.print.difference}:</td>
                        <td className="right">
                            <FormattedNumber
                                style="decimal"
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                                value={(toPrint.getIn(['report', 'diferencePriceMagic', 'CZK'])).toFixed(2)}/> CZK
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td><strong>{msg.print.sales}:</strong></td>
                        <td className="right">
                            <strong>
                                <FormattedNumber
                                  style="decimal"
                                  maximumFractionDigits={2}
                                  minimumFractionDigits={2}
                                  value={(toPrint.getIn(['report', 'revenuePriceMagic', 'CZK'])).toFixed(2)}/> CZK
                            </strong>
                        </td>
                    </tr>
                    </tbody>
                </table>
                }

                {!!tableToPrint && !printDailySum && !!toPrint.get('time') &&
                <small>
                    {msg.print.tableToDate} <DateTime showSec value={toPrint.get('time')}/>
                </small>
                }
                {!tableToPrint && !printDailySum &&
                <small>
                    {!!toPrint.get('time') &&
                    <span>
                            <DateTime showSec value={toPrint.get('time')}/>,&nbsp;
                        </span>
                    }
                    {typeof toPrint.get('number') !== 'undefined' && `${msg.print.documentId} ${deviceId}-${toPrint.get('number')}`}
                    <br/>
                    {!!cashboxes && !!cashboxes.getIn([toPrint.get('cashbox'), 'type']) &&
                    <span>
                        {cashboxes.getIn([toPrint.get('cashbox'), 'type']) === 'CASH'
                            ? msg.print.payInCash
                            : msg.print.payByCard
                        }
                    </span>
                    }
                    {fiscalize
                        ? toPrint.get('eet') !== null && !!toPrint.getIn(['eet', 'fik'])
                            ? <span>, {msg.print.normalMode}</span>
                            : <span>, {msg.print.offlineMode}</span>
                        : <span/>
                    }
                    {fiscalize && !!branch && branch.get('eetBranchId') &&
                    <span>, {msg.print.branch}: {branch.get('eetBranchId')}</span>
                    }
                    <br/>
                    {fiscalize ?
                        toPrint.get('eet') !== null && !!toPrint.getIn(['eet', 'fik'])
                            ? <span/>
                            :
                            <span>{msg.print.onlineBill}: check.ocellot.eu/{deviceId}-{toPrint.get('number')}</span>
                        : <span/>
                    }

                    <br/>

                    {fiscalize && toPrint.get('eet') !== null && !toPrint.getIn(['eet', 'fik']) && !!toPrint.getIn(['eet', 'pkp']) &&
                    <span className="pkp">PKP: {toPrint.getIn(['eet', 'pkp'])}</span>
                    }
                    {fiscalize && toPrint.get('eet') !== null && !!toPrint.getIn(['eet', 'fik']) &&
                    <span>FIK: {toPrint.getIn(['eet', 'fik'])}</span>
                    }
                    <br/>
                    {fiscalize && toPrint.get('eet') !== null && !!toPrint.getIn(['eet', 'bkp']) &&
                    <span>BKP: {toPrint.getIn(['eet', 'bkp'])}</span>
                    }
                </small>
                }

                <br/>
                <br/>

                {!!!toPrint.get('isInformative') &&
                    <footer className="menu-hide">
                        {msg.print.thankYou}
                        <br/>
                        <small>{msg.print.soldAndPrint}</small>
                    </footer>
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    bar: state.bars.get('bar'),
    printDailySum: state.barReport.get('printDailySum'),
    dailySum: state.barReport.get('dailySum'),
    organization: state.categories.get('organization'),
    logo: state.categories.get('logo'),
    orderToPrint: state.categories.get('orderToPrint'),
    tableToPrint: state.categories.get('tableToPrint'),
    branch: state.branches.get('branch'),
    cashboxes: state.cashboxes.get('cashboxes'),
    deviceId: state.device.get('id'),
    printType: state.device.get('printType')
}))(Print);



// WEBPACK FOOTER //
// ./src/browser/print/Print.js